import { Operation } from "./Operation";

export class OplaneradOperation extends Operation {
    #pk;
    #personId;
    #personId_formatted;
    #code;

    constructor(pk, personId, personId_formatted, code, forberedelsetid, avvecklingstid, optid, patient) {
        super(forberedelsetid, avvecklingstid, optid, patient);

        this.#pk = pk;
        this.#personId = personId;
        this.#personId_formatted = personId_formatted;
        this.#code = code;
    }

    get pk() {
        return this.#pk;
    }

    get personId() {
        return this.#personId;
    }

    getpersonId_formatted() {
        return this.#personId_formatted;
    }

    get code() {
        return this.#code;
    }

    toJSON() {
        const { pk, personId, personId_formatted, code, forberedelsetid, avvecklingstid, optid, patient } = this;
        return {
            pk,
            personId,
            personId_formatted,
            code,
            forberedelsetid,
            avvecklingstid,
            optid,
            patient,
        };
    }
}
